import "../CSS/style.css";
import { Link } from "react-router-dom";
import maudyAyunda from "../images/maudy-removebg.png";
import lebronJames from "../images/lbjj-removebg.png";
import deddyCorbuzier from "../images/dd-removebg.png";
import pevitaPearce from "../images/pevita-removebg.png";
const Lecturer = () => {
  return (
    <section className="lecturerContainer">
      <div className="lecturerTitle">
        <p className="homePage-title" style={{ color: "white" }}>
          Pembicara
        </p>
      </div>
      <div className="cardContainer">
        <div className="C--card type--1-tfi" style={{}}>
          <img className="card__image" src={deddyCorbuzier} alt="" />
          <div className="card__body">
            <h3 class="card__title">Pak Hermawan</h3>
            <span className="card__subtitle">Uncategorized</span>
            <p className="card__text">
              Some quick example text to build on the card title and make up the
              bulk of the card's content.
            </p>
            <p className="readMoreText">Read more</p>
          </div>
        </div>

        <div className="C--card type--1-tfi">
          <img className="card__image" src={maudyAyunda} alt="" />
          <div className="card__body">
            <h3 class="card__title">Pak Handimin</h3>
            <span className="card__subtitle">Uncategorized</span>
            <p className="card__text">
              Some quick example text to build on the card title and make up the
              bulk of the card's content.
            </p>
            <p className="readMoreText">Read more</p>
          </div>
        </div>

        <div className="C--card type--1-tfi">
          <img className="card__image" src={lebronJames} alt="" />
          <div className="card__body">
            <h3 class="card__title">Pak Handimin</h3>
            <span className="card__subtitle">Uncategorized</span>
            <p className="card__text">
              Some quick example text to build on the card title and make up the
              bulk of the card's content.
            </p>
            <p className="readMoreText">Read more</p>
          </div>
        </div>

        <div className="C--card type--1-tfi" style={{}}>
          <img className="card__image" src={pevitaPearce} alt="" />

          <div className="card__body">
            <h3 class="card__title">Miss Sally</h3>
            <span className="card__subtitle">Uncategorized</span>
            <p className="card__text">
              Some quick example text to build on the card title and make up the
              bulk of the card's content.
            </p>
            <p className="readMoreText">Read more</p>
          </div>
        </div>
      </div>
      <div className="lecturer-buttonContainer">
        <Link to="/Pembicara">
          <button className="viewAllButton" style={{ color: "white" }}>
            View All
          </button>
        </Link>
      </div>
    </section>
  );
};

export default Lecturer;
